var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 33,
    viewBox: "0 0 31 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_79_31)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_79_31",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 31,
    height: 33
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 0.5H0.5V32.5H30.5V0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_79_31)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5645 2.64267C12.8011 2.05796 13.2069 1.55723 13.7299 1.20464C14.2529 0.85206 14.8692 0.663696 15.5 0.663696C16.1307 0.663696 16.7471 0.85206 17.2701 1.20464C17.7931 1.55723 18.1989 2.05796 18.4355 2.64267C20.7769 3.28658 22.8421 4.6813 24.314 6.61262C25.786 8.54393 26.5832 10.905 26.5833 13.3333V20.7703L29.484 25.1213C29.6431 25.3597 29.7345 25.6369 29.7484 25.9232C29.7623 26.2095 29.6982 26.4942 29.563 26.747C29.4277 26.9997 29.2264 27.211 28.9805 27.3583C28.7346 27.5056 28.4533 27.5834 28.1667 27.5833H20.9862C20.7956 28.9024 20.1361 30.1087 19.1285 30.9811C18.1209 31.8535 16.8328 32.3337 15.5 32.3337C14.1672 32.3337 12.879 31.8535 11.8715 30.9811C10.8639 30.1087 10.2044 28.9024 10.0137 27.5833H2.83333C2.54668 27.5834 2.26539 27.5056 2.01948 27.3583C1.77357 27.211 1.57226 26.9997 1.43703 26.747C1.30179 26.4942 1.23771 26.2095 1.25162 25.9232C1.26553 25.6369 1.3569 25.3597 1.51599 25.1213L4.41666 20.7703V13.3333C4.41666 8.22867 7.86833 3.92834 12.5645 2.64267ZM13.2612 27.5833C13.4247 28.0467 13.7279 28.4479 14.129 28.7317C14.5301 29.0155 15.0094 29.168 15.5008 29.168C15.9922 29.168 16.4714 29.0155 16.8725 28.7317C17.2737 28.4479 17.5769 28.0467 17.7404 27.5833H13.2612ZM15.5 5.41667C13.4004 5.41667 11.3867 6.25074 9.90206 7.73541C8.4174 9.22007 7.58333 11.2337 7.58333 13.3333V21.25C7.5834 21.5628 7.49084 21.8685 7.31733 22.1288L5.79258 24.4167H25.2058L23.6811 22.1288C23.5081 21.8684 23.4161 21.5626 23.4167 21.25V13.3333C23.4167 11.2337 22.5826 9.22007 21.0979 7.73541C19.6133 6.25074 17.5996 5.41667 15.5 5.41667Z",
    fill: "#EBB42C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_79_31"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 32,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.3b154e3d82be0add07fd54e6cb24af59.svg";
export { ForwardRef as ReactComponent };